import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AUTH_REFRESH_RETRIED, AuthService } from './auth';

function isAuthEndpoint(url: string): boolean {
  return (
    url.includes('/platform/auth/token') ||
    url.includes('/platform/auth/totp/verify') ||
    url.includes('/platform/auth/refresh') ||
    url.includes('/platform/auth/logout')
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  if (req.url.startsWith('/health') || isAuthEndpoint(req.url)) {
    return next(req);
  }

  const token = auth.accessToken();
  const authedReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : req;

  return next(authedReq).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== 401) {
        return throwError(() => err);
      }

      if (req.context.get(AUTH_REFRESH_RETRIED)) {
        return throwError(() => err);
      }

      if (!auth.hasRefreshableSession()) {
        auth.logout();
        return throwError(() => err);
      }

      return auth.refreshAndRetry(req, next);
    }),
  );
};
